import Cookie from 'js-cookie'

// 创建 XMLHttpRequest 实例的工厂函数
function createXHR() {
	return new XMLHttpRequest();
}

// 处理请求配置
function processRequestConfig(config) {
	if (!config.url) {
		return null;
	}
	
	if (config.url.indexOf("http") !== 0) {
		const BaseUrl = process.env.NODE_ENV === "development" ? 'https://test2.meiguanjia.net' : window.location.origin;
		config.url = BaseUrl + '/mgj_api' + config.url;
	}
	
	const parentShopId = (config.data && config.data.tenantId) || Cookie.get("realParentShopId");
	config.url = config.url.replace("{parentShopId}", parentShopId);
	
	return config;
}

// 创建请求实例
const AxiosInstance = {
	timeout: 10000,
	headers: {
		'Content-Type': 'application/json',
		"request-from": "MGJ_SHAIR",
		"Token": Cookie.get('token') || '',
	},
	
	// 请求拦截器
	interceptors: {
		request: {
			use: function(handler) {
				this.requestHandler = handler;
			}
		},
		response: {
			use: function(successHandler, errorHandler) {
				this.successHandler = successHandler;
				this.errorHandler = errorHandler;
			}
		}
	},
	
	// 创建请求实例
	create: function(config) {
		const instance = Object.create(this);
		Object.assign(instance, config);
		return instance;
	},
	
	// GET 请求
	get: function(url, config) {
		return this.request(Object.assign({ method: 'GET', url: url }, config));
	},
	
	// POST 请求
	post: function(url, data, config) {
		return this.request(Object.assign({ method: 'POST', url: url, data: data }, config));
	},
	
	// PUT 请求
	put: function(url, data, config) {
		return this.request(Object.assign({ method: 'PUT', url: url, data: data }, config));
	},
	
	// DELETE 请求
	delete: function(url, config) {
		return this.request(Object.assign({ method: 'DELETE', url: url }, config));
	},
	
	// 通用请求方法
	request: function(config) {
		return new Promise((resolve, reject) => {
			const xhr = createXHR();
			
			// 处理请求配置
			let processedConfig = config;
			if (this.interceptors.request.requestHandler) {
				processedConfig = this.interceptors.request.requestHandler(processedConfig) || processedConfig;
			}
			
			if (!processedConfig) {
				reject(new Error('Invalid request config'));
				return;
			}
			
			// 设置超时
			xhr.timeout = processedConfig.timeout || this.timeout || 10000;
			
			// 设置响应类型
			if (processedConfig.responseType) {
				xhr.responseType = processedConfig.responseType;
			}
			
			// 监听状态变化
			xhr.onreadystatechange = function() {
				if (xhr.readyState === 4) {
					let response = {
						data: null,
						status: xhr.status,
						statusText: xhr.statusText,
						headers: {},
						config: processedConfig,
						request: xhr
					};
					
					// 解析响应头
					const headerString = xhr.getAllResponseHeaders();
					const headers = headerString.trim().split(/[\r\n]+/);
					headers.forEach(function(line) {
						const parts = line.split(': ');
						const header = parts.shift();
						const value = parts.join(': ');
						if (header && value) {
							response.headers[header.toLowerCase()] = value;
						}
					});
					
					// 解析响应数据
					if (processedConfig.responseType === 'blob') {
						response.data = xhr.response;
					} else {
						try {
							response.data = JSON.parse(xhr.responseText);
						} catch (e) {
							response.data = xhr.responseText;
						}
					}
					
					// 处理响应
					if (xhr.status >= 200 && xhr.status < 300) {
						if (AxiosInstance.interceptors.response.successHandler) {
							try {
								const result = AxiosInstance.interceptors.response.successHandler(response);
								resolve(result);
							} catch (error) {
								reject(error);
							}
						} else {
							resolve(response);
						}
					} else {
						const error = new Error('Request failed with status ' + xhr.status);
						error.response = response;
						error.config = processedConfig;
						error.request = xhr;
						
						if (AxiosInstance.interceptors.response.errorHandler) {
							try {
								const result = AxiosInstance.interceptors.response.errorHandler(error);
								reject(result);
							} catch (handlerError) {
								reject(handlerError);
							}
						} else {
							reject(error);
						}
					}
				}
			};
			
			// 监听错误
			xhr.onerror = function() {
				const error = new Error('Network Error');
				error.config = processedConfig;
				error.request = xhr;
				
				if (AxiosInstance.interceptors.response.errorHandler) {
					try {
						const result = AxiosInstance.interceptors.response.errorHandler(error);
						reject(result);
					} catch (handlerError) {
						reject(handlerError);
					}
				} else {
					reject(error);
				}
			};
			
			// 监听超时
			xhr.ontimeout = function() {
				const error = new Error('Request timeout');
				error.config = processedConfig;
				error.request = xhr;
				
				if (AxiosInstance.interceptors.response.errorHandler) {
					try {
						const result = AxiosInstance.interceptors.response.errorHandler(error);
						reject(result);
					} catch (handlerError) {
						reject(handlerError);
					}
				} else {
					reject(error);
				}
			};
			
			// 打开连接
			xhr.open(processedConfig.method.toUpperCase(), processedConfig.url, true);
			
			// 设置请求头
			const headers = Object.assign({}, this.headers, processedConfig.headers);
			for (let key in headers) {
				if (Object.prototype.hasOwnProperty.call(headers, key)) {
					xhr.setRequestHeader(key, headers[key]);
				}
			}
			
			// 发送请求
			let requestData = null;
			if (processedConfig.data) {
				if (typeof processedConfig.data === 'object') {
					requestData = JSON.stringify(processedConfig.data);
				} else {
					requestData = processedConfig.data;
				}
			}
			
			xhr.send(requestData);
		});
	}
};

// 设置拦截器
AxiosInstance.interceptors.request.use(function (config) {
	return processRequestConfig(config);
});

AxiosInstance.interceptors.response.use(function (res) {
	const resData = res.data;
	const responseType = res.config.responseType;
	if (responseType === 'blob') {
		return Promise.resolve(res);
	}
	else if (resData.success) {
		return Promise.resolve(resData);
	} else {
		return Promise.reject(resData);
	}
}, function (error) {
	return Promise.reject(error);
});

export default AxiosInstance;